import { render } from 'preact';
import { App } from './App';
import { iniciarPwa } from './pwa';
import { iniciarTema } from './tema';
import './styles.css';
import './admin.css';
import './impacto.css';
import './coleta.css';
import './ui.css';

iniciarTema();
iniciarPwa(); // o convite "Instalar app" do navegador pode chegar antes de a tela desenhar: precisa ser ouvido desde já

render(<App />, document.getElementById('app')!);

// Deixa o app abrir sem internet (pesquisador em campo) e instalável. Só no build de produção: em desenvolvimento o cache atrapalharia.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker
      .register('/sw.js')
      .then(() => navigator.serviceWorker.ready)
      .then((reg) => {
        // Guarda já na primeira visita tudo o que a página carregou (o service worker só intercepta a partir da próxima).
        const urls = ['/', ...performance.getEntriesByType('resource').map((r) => r.name)].filter((u) => new URL(u, location.href).origin === location.origin && !u.includes('/api/'));
        reg.active?.postMessage({ tipo: 'guardar', urls });
      })
      .catch(() => {});
  });
}
